"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var js_version = require('../../package.json').version;
var Hub = /** @class */function () {
  function Hub(data) {
    if (data === void 0) {
      data = {};
    }
    this.system = '';
    this.entity = '';
    this.action = '';
    this.data_version = '';
    this.event_version = '1.1';
    this.hub = {
      js_version: js_version
    };
    this.event = {};
    Object.assign(this, data);
  }
  return Hub;
}();
exports.default = Hub;